import responseCodes from '../../const/responseCodes';
var getErrorCode = function (authorizationErrorCode, alertsErrorCode, consentErrorCode) {
    var errorCode = "".concat(responseCodes.NOT_FOUND);
    if (authorizationErrorCode !== '')
        errorCode = authorizationErrorCode;
    if (alertsErrorCode !== '')
        errorCode = alertsErrorCode;
    if (consentErrorCode !== '')
        errorCode = consentErrorCode;
    return errorCode;
};
export default getErrorCode;
